import { AssetChubbBookingBannerInterface } from '@app/entities/asset-chubb-booking-banner';
import { ReservationType } from '@user-history/entities/user-history-item';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { AssetChubbBookingBannerBase } from './asset-chubb-booking-banner.base';

export const AssetChubbBookingBanner: AssetChubbBookingBannerInterface = {
  ...AssetChubbBookingBannerBase,
  ENABLED_FREE_ASSISTANCE: {
    TYPES: [],
    IS_NATIONAL_TRIP: false,
    IS_INTERNATIONAL_TRIP: false,
    ONLY_PRIME_USER: false,
  },
  ENABLED_ASSISTANCE_INTERFACE: [
    TravelBookingType.FLIGHTS,
    TravelBookingType.FLIGHTS_BY_SECTOR,
    TravelBookingType.PACKAGE_AIR,
  ],
  ENABLED_ASSISTANCE_INTERFACE_DETAIL: [
    ReservationType.Flight,
    ReservationType.AirPackage,
  ],
  LATERAL_BANNER: null,
  NATIONAL_COPY_BY_PRIME_GIFT: 'USD 1,3',
  INTERNATIONAL_COPY_BY_PRIME_GIFT: 'USD 5,04',
  NATIONAL_COPY_OPTIONS: [
    'Gastos médicos por enfermedad o accidente (incluyendo COVID 19), tienes una cobertura de hasta $500 USD',
    'Si tu viaje se retrasa, tienes una cobertura de hasta $100 USD',
    'Si se te demora el equipaje, obtienes una indemnización de hasta $70 USD',
    'Si se te pierde el equipaje, obtienes una indemnización de hasta $70 USD',
    'En caso de muerte accidental en viaje, cubre una indemnización de $2,000 USD',
  ],
  INTERNATIONAL_COPY_OPTIONS: [
    'Gastos médicos por enfermedad o accidente (incluyendo COVID 19), tienes una cobertura de hasta $3.000 USD',
    'Si tu viaje se retrasa, tienes una cobertura de hasta $200 USD',
    'Si se te demora el equipaje, obtienes una indemnización de hasta $100 USD',
    'Si se te pierde el equipaje, obtienes una indemnización de hasta $100 USD',
    'En caso de muerte accidental en viaje, cubre una indemnización de $2,500 USD'
  ],
  ASSISTANCE: {
    ...AssetChubbBookingBannerBase.ASSISTANCE,
    TERMS_TITLE: 'Términos y condiciones seguro colectivo de viaje, Chubb Seguros México, S.A.',
    ASSISTANCE_TERMS: [
      {
        TITLE: '',
        PARAGRAPHS: [
          `<strong>
          Para las coberturas mencionadas en las distintas secciones de este 
          seguro no se amparan los eventos que se originen por participación 
          del Asegurado en actividades como:`,
          '1. Servicio militar, actos de guerra, rebelión, insurrección o revolución.',
          '2. Actos delictivos intencionales en que participe directamente el Asegurado.',
          `3. Lesiones recibidas al participar el Asegurado en una riña, 
          cuando esta haya sido provocada por el propio Asegurado.`,
          `4. Suicidio, lesiones o alteraciones originadas por intento del mismo, 
          aun cuando se cometa en estado de enajenación mental.`,
          `5. Que se originen por culpa grave del Asegurado cuando se 
          encuentre bajo el efecto de drogas enervantes o alucinógenas, 
          fármacos o bien ingerir somníferos, barbitúricos, estupefacientes o 
          substancias con efectos similares, no prescritos por un médico.`,
          `6. Enfermedades Preexistentes, salvo en lo definido para la cobertura 
          de “Estabilización en caso de Padecimientos Preexistentes”.`,
          '7. Aviación privada en calidad de tripulante, piloto, mecánico en vuelo o Pasajero.',
          `8. Accidentes que ocurran mientras el Asegurado se encuentre a bordo de cualquier 
          Transporte Público que no esté legalmente establecido y autorizado, a menos que 
          viajare como Pasajero.`,
          `9. Pruebas o contiendas de velocidad, resistencia o seguridad 
          en vehículos de cualquier tipo.`,
          `10. Miembro de la tripulación de cualquier Transporte Público legalmente 
          establecido y autorizado (servicio comercial y privado).`,
          `11. Como conductor o Pasajero de motocicletas y/o vehículos de motor 
          similares acuáticos y terrestres.`,
          `12. La práctica tanto en capacitación, entrenamiento o competencia, 
          ya sea en carácter profesional, Amateur o recreativo de deportes peligrosos 
          o de alto riesgo, incluyendo, entre otros: motociclismo, automovilismo, boxeo, 
          rugby, polo, moto de nieve, esquí en agua, arena o cualquiera de sus formas, 
          cuadriciclos, vehículos todo terreno, skate, parapente, paracaidismo, planeadores, 
          aviación deportiva, tauromaquia, espeleología, aladeltismo, escalamiento de montañas,
           motocross, trekking, rafting, hockey en cualquiera de sus formas, patinaje artístico 
           sobre hielo o sobre pista, equitación en salto o carreras, artes marciales de cualquier 
           tipo, salvo lo estipulado en la cobertura Gastos Médicos por Práctica de Deportes de 
           Alto Riesgo.`,
          `13. No se considerarán como Accidente las lesiones corporales causadas intencionalmente 
          por el Asegurado, así como aquellos casos donde la primera atención y el primer gasto 
          médico se realicen después de cuarenta y ocho (48) horas siguientes a la fecha en 
          que ocurrió el hecho que les dio origen.`,
          `14. Accidentes o Enfermedades que ocurran por el ejercicio de una actividad 
          de alto riesgo que estuviera realizando el Asegurado incluyendo pero no limitando 
          a: trabajos en obras, andamios, alturas, pozos, utilización de maquinarias, 
          instrumentos de corte, manejo o manipulación de mercancías u objetos pesados o peligrosos, 
          productos tóxicos, corrosivos, explosivos o inflamables, actividades agrícolas 
          y/o transportistas.`,
          `15. Esta Póliza cubre los riesgos señalados en la misma en el territorio de los 
          Estados Unidos Mexicanos y/o en el extranjero, en ambos casos, para mexicanos o 
          personas con residencia permanente en los Estados Unidos Mexicanos y atendiendo 
          a las condiciones particulares de cada una de las coberturas descritas en las 
          presentes disposiciones y lo definido en la Carátula de la Póliza y/o Certificado 
          Individual. En el caso de viajes al extranjero, no cubrirá aquellos que se realicen 
          a los siguientes países: Cuba, Afganistán, República Democrática del Congo, Irak, 
          Irán, Liberia, Sudán, Siria, Corea del Norte, Yemen, República de Zimbabue y República 
          Centroafricana, así como los países sanciones por la OFAC. Los viajes realizados a, 
          en o a través de estos países estarán excluidos de la presente Póliza y por lo tanto 
          no se cubrirá ninguna pérdida, lesión, daño, responsabilidad civil, beneficio o servicio 
          señalado en la Póliza. La contratación de la presente Póliza cuyo destino o tránsito por lo 
          países señalados con anterioridad esté considerada por el Asegurado, dejará sin efectos la 
          Póliza y causará la devolución de las primas pagadas por el mismo.`,
        ]
      },
      {
        TITLE: 'Vigencia del contrato',
        PARAGRAPHS: [
          `Este Contrato de Seguro iniciará su vigencia a partir de las 12:00 horas 
          de la fecha especificada en la Carátula de la Póliza y terminará su vigencia 
          a las 12:00 horas de la fecha indicada en la mencionada Carátula de Póliza.`,
          `Durante la vigencia del Contrato de Seguro tendrán lugar altas y bajas de Asegurados, 
          a través de Certificados Individuales. La vigencia en relación con cada Certificado 
          Individual iniciará a partir de las 12:00 horas de la fecha de alta especificada en 
          el Certificado Individual y terminará su vigencia a las 12:00 horas de la fecha establecida 
          en el mencionado Certificado Individual.`,
        ]
      },
      {
        TITLE: 'Cancelación',
        PARAGRAPHS: [
          `El Contratante podrá dar por terminado anticipadamente este seguro, 
          mediante aviso por escrito a la Compañía. La terminación anticipada no eximirá a 
          la Compañía del pago de las reclamaciones originadas y determinadas como 
          procedentes mientras el seguro y/o Certificado Individual estuvieron en 
          vigor al ocurrir el siniestro.`,
          `El seguro y/o Certificado Individual quedará cancelado en la fecha en que la 
          solicitud escrita del Contratante sea recibida por la Compañía o en la 
          fecha especificada en la solicitud, la que sea posterior. 
          Este seguro se cancelará automáticamente al ocurrir cualquiera de los siguientes eventos:`,
          `a) Para cada Asegurado, en la renovación inmediata posterior a la fecha en 
          la que el Asegurado haya alcanzado la edad máxima de renovación.`,
          'b) Para cada Asegurado, al ocurrir el fallecimiento del Asegurado, por cualquier circunstancia.',
          'c) Para cada Asegurado, si cambia su lugar de residencia fuera de los Estados Unidos Mexicanos.',
          `d) Para cada Asegurado, si este deja de reunir las características para pertenecer a 
          la Colectividad Asegurada, según sea determinado por el Contratante.`,
          `e) Por falta de pago de las primas, de conformidad con lo establecido en 
          la Cláusula Primera de las Disposiciones Generales.`,
          `En caso de que el Contratante solicite la cancelación anticipada del seguro, la Compañía devolverá 
          la prima neta pagada no devengada, descontando el costo de los derechos de Póliza, estipulados en 
          la Carátula de la misma, así como las comisiones y/o gastos de adquisición. La Compañía realizará 
          dicha devolución al Contratante dentro de los 30 (treinta) días hábiles siguientes a la solicitud de 
          cancelación, mediante cheque o transferencia bancaria, de acuerdo con lo solicitado por el Contratante. 
          En caso de que la Compañía requiera dar por terminado anticipadamente este contrato, deberá notificar 
          por escrito al Contratante, enviando un aviso por correo certificado con cuando menos siete días 
          naturales de anticipación a la 
          fecha en que se deseé su terminación, debiendo además devolver la parte de la prima no devengada 
          correspondiente descontando el costo de los derechos de Póliza estipulados en la Carátula de la misma, 
          así como las comisiones 
          y/o gastos de adquisición. Esta terminación anticipada por parte de la Compañía no aplicará 
          para las coberturas Muerte Accidental, Gastos Funerarios a consecuencia de Muerte Accidental, 
          Gastos Funerarios a consecuencia de Muerte Accidental para Dependientes Económicos menores de 12 años, 
          Invalidez Total y Permanente por Accidente, Muerte Accidental en Transporte Público, Pérdidas Orgánicas a 
          Causa de Accidente, Pérdidas Orgánicas a Causa de Accidente en un Medio de Transporte Público, Gastos 
          Médicos por Accidente y/o Enfermedad, Gastos Médicos por Práctica de Deportes de Alto Riesgo, Gastos 
          por Emergencia Odontológica, Gastos Funerarios o Traslado de Restos Mortales, Reembolso por Compra de 
          Medicamentos Recetados, Gastos de Enfermera Particular, Traslados Médicos de Emergencia y Traslados 
          Sanitarios y Estabilización en caso de Padecimientos Preexistentes, siempre que el Asegurado las 
          tenga contratadas en su Póliza.`,
        ]
      },
      {
        TITLE: 'Edad',
        PARAGRAPHS: [
          `Se considera como edad, la edad alcanzada del Asegurado, consistente en el número de años 
          cumplidos en la fecha de contratación del seguro y las subsecuentes contrataciones.`,
          `Las edades de aceptación para el presente seguro serán de mínimo un (1) mes de edad 
          y máximo de ochenta y cinco (85) años, con excepción de las coberturas de muerte accidental 
          en donde la edad mínima de aceptación es de doce (12) años. La edad máxima de renovación 
          será la que se especifique en la Carátula de la Póliza.`,
          `La edad del Asegurado asentada en esta Póliza podrá comprobarse presentando pruebas 
          fehacientes a la Compañía quien lo anotará en la Póliza o extenderá el comprobante 
          respectivo y no tendrá derecho para pedir nuevas pruebas. Este requisito debe cubrirse 
          antes de que la Compañía efectúe el pago de cualquier Beneficio.`,
          `Cuando se compruebe que hubo inexactitud en la indicación de la edad del Asegurado, 
          la Compañía no podrá rescindir el Contrato, a no ser que la edad real al tiempo de 
          su celebración esté fuera de los límites de admisión fijados por
          la Compañía, pero en este caso se devolverá al Asegurado la reserva matemática del 
          Contrato en la fecha de su rescisión. Si la edad del Asegurado estuviere comprendida 
          dentro de los límites de admisión fijados por la Compañía, se aplicarán las siguientes reglas:`,
          `I. Cuando a consecuencia de la indicación inexacta de la edad, se pagare una prima menor de 
          la que correspondería por la edad real, la obligación de la Compañía se reducirá en la proporción 
          que exista entre la prima estipulada y la prima de tarifa para la edad real en la fecha de 
          celebración del Contrato.`,
          `II. Si la Compañía hubiere satisfecho ya el importe del seguro al descubrirse la inexactitud 
          de la indicación sobre la edad del Asegurado tendrá derecho a exigir al Asegurado o Beneficiarios 
          lo que hubiere pagado de más conforme al cálculo del inciso anterior, incluyendo los intereses respectivos.`,
          `III. Si a consecuencia de la inexacta indicación de la edad, se estuviere pagando una prima más 
          elevada que la correspondiente a la edad real, la Compañía estará obligada a reembolsar 
          la diferencia entre la reserva existente y la que habría sido necesaria para la edad real 
          del Asegurado en el momento de la celebración del Contrato. Las primas ulteriores deberán 
          reducirse de acuerdo con esta edad.`,
          `IV. Si con posterioridad a la ocurrencia del siniestro se descubriera que fue incorrecta 
          la edad manifestada, y esta se encuentra dentro de los límites de admisión autorizados, 
          la Compañía estará obligada a pagar la Suma Asegurada que las Primas cubiertas hubieren 
          podido pagar de acuerdo con la edad real.`,
          `Para los cálculos que exige la presente cláusula se aplicarán las tarifas que hayan estado 
          en vigor al tiempo de la celebración del Contrato.`,
        ]
      },
      {
        TITLE: 'Administración y Acceso a la Información',
        PARAGRAPHS: [
          `La Compañía y el Contratante en este acto acuerdan que para efectos de facilitar y 
          hacer eficiente el proceso de administración y gestión del seguro, 
          la administración del mismo será responsabilidad del Contratante, por lo que el 
          Contratante se obliga a recabar y a proporcionar a la Compañía la información necesaria 
          y suficiente, a efecto de que la Compañía cumpla en tiempo y forma con lo establecido en 
          el Reglamento, en el ACUERDO por el que se emiten las disposiciones de carácter general 
          a que se refiere el artículo 492 de la Ley de Instituciones de Seguros y de Fianzas, 
          aplicables a instituciones y sociedades mutualistas de seguros, demás legislación y normatividad 
          aplicable y cualquier requerimiento de alguna autoridad.`,
          `El presente documento es de carácter informativo para conocer el documento completo de 
          Condiciones Generales aplicables, consultar requisitos de contratación y exclusiones 
          de la póliza ponemos a su disposición la siguiente página: 
          https://www.chubb.com/mx-es/condiciones-generales.html`,
          `He leído y acepto el aviso de privacidad el cual se encuentra a mi disposición en 
          https://www.chubb.com/mx-es/footer/privacy-notices.aspx `,
          `En caso de controversia, usted podrá hacer valer sus derechos ante la
          Unidad Especializada de Atención de Consultas y Reclamaciones de Chubb
          Seguros México, S.A. (UNE), al correo electrónico uneseguros@chubb.com,
          o al teléfono 800 006 3342 de lunes a jueves de 8:30 hrs. a
          17:00 hrs. y viernes de 8:30 hrs. a 14:00 hrs.`,
          `En caso de que su queja o consulta no haya sido atendida también podrá
          referirse a la Comisión Nacional para la Protección y Defensa de los
          Usuarios de Servicios Financieros (CONDUSEF) al 55 5340 0999
          a nivel nacional o por correo a: asesoria@condusef.gob.mx de sus datos 
          personales, patrimoniales, financieros y/o sensibles de conformidad 
          con el Aviso de Privacidad Integral que le fue previamente puesto a su 
          disposición y que se encuentra disponible en https://www2.chubb.com/mx-es/
          Producto(s) ofrecido(s) y operado(s) por Chubb Seguros México, S.A.
          Esta es una oferta de producto sólo para residentes en México.`,
        ]
      }
    ],
    CHECKBOX_MESSAGE_TERMS: 'Acepto los términos y condiciones del seguro y el aviso de privacidad.',
  }
};
